<script setup>
import { SignUp } from '@clerk/vue'

import AuthPageLayout from '@web-app/login-app/AuthPageLayout'
import { useLoginAppRoutes } from '@web-app/utils/route-helpers'

defineOptions({
  name: 'WebAppSignUp'
})

const { gatewayPath } = useLoginAppRoutes()
</script>

<template>
  <AuthPageLayout>
    <SignUp :fallback-redirect-url="gatewayPath" />
  </AuthPageLayout>
</template>

<style lang="scss" scoped></style>
